module.exports = __webpack_public_path__ + "img/word-of-mouth-2.8c21ceb9.png";